export default "__VITE_ASSET__DPVilPv___"